var exports = {
  "k": "x52a3aa3b--847c64--container",
  "w": "x52a3aa3b--847c64--postfix",
};

module.exports = exports;
